import { ProjectViewModel } from "../ViewModel/ProjectViewModel";
import getSpdrsForList from "./LeftSide/InboundTab/GetSpdrsForList";
import getPdsrsForList from "./LeftSide/ReturnTab/GetPdsrsForList";
import { RouteEditTab } from "./RouteEditTab";
import { LtlPipelineViewModel } from "../ViewModel/LtlPipelineViewModel";
import { SpdrClientViewModel } from "../ViewModel/SpdrClientViewModel";
import { PdsrClientViewModel } from "../ViewModel/PdsrClientViewModel";

export function initLtlPipelines(project: ProjectViewModel): ProjectViewModel {
  const spdrs =
    getSpdrsForList(
      RouteEditTab.Ltl,
      project.SpdrsOnThisProject,
      project.FTLRoutes
    ) || [];

  const pdsrs =
    getPdsrsForList(
      RouteEditTab.Ltl,
      project.PdsrsOnThisProject,
      project.FTLRoutes
    ) || [];

  spdrs.forEach((spdr: SpdrClientViewModel) => {
    const spdrId = spdr.SpdrId;

    const ltlPipeline = project?.ltlPipelines?.find((p) => p.SpdrId === spdrId);
    if (!ltlPipeline) {
      const newLtlPipeline: LtlPipelineViewModel = {
        SpdrId: spdr.SpdrId,
        SupplierGsdb: spdr.SupplierGsdb,
        PlantGsdb: spdr.PlantGsdb,
        DockCode: spdr.DockCode,
        SupplierShipFrequency:
          spdr.ShipFrequency === 0
            ? project?.GlobalLtlShipFrequency
            : spdr.ShipFrequency,
        JitKanban: false,
        TTAdjustment: undefined,
        routing: [],
      };
      project.ltlPipelines?.push(newLtlPipeline);
    }
  });

  pdsrs.forEach((pdsr: PdsrClientViewModel) => {
    const pdsrId = pdsr.PdsrId;

    const ltlPipeline = project?.ltlPipelines?.find((p) => p.PdsrId === pdsrId);
    if (!ltlPipeline) {
      const newLtlPipeline: LtlPipelineViewModel = {
        PdsrId: pdsr.PdsrId,
        SupplierGsdb: pdsr.SupplierGsdb,
        PlantGsdb: pdsr.PlantGsdb,
        ContainerNetwork: pdsr.ContainerNetwork,
        DockCode: pdsr.DockCode,
        SupplierShipFrequency:
          pdsr.ShipFrequency === 0
            ? project?.GlobalLtlShipFrequency
            : pdsr.ShipFrequency,
        JitKanban: false,
        TTAdjustment: undefined,
        routing: [],
      };
      project.ltlPipelines?.push(newLtlPipeline);
    }
  });

  return project;
}
